import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SentryService } from "../services/sentry.service";
import { EnvironmentService } from '../services/environment.service';
import { isChunkLoadError, reloadForChunkLoadError } from '../util/chunk-load-util';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private environmentService = inject(EnvironmentService);
    private sentryService = inject(SentryService);
    handleError(error: any): void {
        // A lazy route whose chunk is gone after a deploy: reload onto the current build
        // instead of reporting it (Sentry's beforeSend drops these as well).
        if (isChunkLoadError(error?.message ?? error?.rejection?.message)) {
            this.reloadPage();
            return;
        }
        if (!(error instanceof HttpErrorResponse)) {
            console.error('An error occurred:', error);
            // Non-HTTP error: register with Sentry
            if (error instanceof Error) {
                 this.sentryService.captureException(error, undefined, {
                    app_version: this.environmentService.env.appVersion,
                });
            } else {
                const customError = new Error('A non-Error object was captured');
                // Attach original data for context
                this.sentryService.captureException(customError, {
                    'originalException': error
                }, {
                    app_version: this.environmentService.env.appVersion,
                });
            }
        }
    }

    protected reloadPage(): void {
        reloadForChunkLoadError();
    }
}